import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';
import * as R from 'ramda';

import * as alert from '../../../../common/services/alert';
import { Button } from '../../../../common/components/button';
import { Row, Group, CheckboxInput } from '../../../../common/components/form';
import updateNetwork from '../../actions/update-network';
import { EComponentTypes } from '../../../../common/definitions';

function isEnabled(network, organisation, component) {
  return (
    network.enabled_components.includes(component) &&
    organisation.available_components.includes(component)
  );
}

class NetworkComponentsForm extends Component {
  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { network, initialize, organisation } = this.props;

    if (!network || !network.enabled_components || !organisation?.available_components) return;

    initialize({
      [EComponentTypes.SCHEDULE]: isEnabled(network, organisation, EComponentTypes.SCHEDULE),
      // $FlowFixMe seems like a bug
      [EComponentTypes.FLEXCHANGE]: isEnabled(network, organisation, EComponentTypes.FLEXCHANGE),
    });
  }

  static props;

  async handleSubmit(values, dispatch) {
    try {
      const enabledComponents = R.filter(R.equals(true), values);

      await dispatch(updateNetwork({
        enabled_components: Object.keys(enabledComponents),
      }));

      alert.success(this.props.t('network:forms_components_success'));
    } catch (response) {
      alert.forStatus(response.status_code, {
        warning: this.props.t('network:forms_components_warning'),
        error: this.props.t('network:forms_components_error'),
      });
    }
  }

  render() {
    const { organisation, handleSubmit, submitting, t } = this.props;

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)} className="Form Form--horizontal">
        {organisation.available_components.includes(EComponentTypes.SCHEDULE) && (
          <Row>
            <Group>
              <CheckboxInput
                name={EComponentTypes.SCHEDULE}
                label={t('network:forms_components_schedule_title')}
                description={t('network:forms_components_schedule_description')}
              />
            </Group>
          </Row>
        )}
        {organisation.available_components.includes(EComponentTypes.FLEXCHANGE) && (
          <Row>
            <Group>
              <CheckboxInput
                name={EComponentTypes.FLEXCHANGE}
                label={t('network:forms_components_flexchange_title')}
                description={t('network:forms_components_flexchange_description')}
              />
            </Group>
          </Row>
        )}
        <Row>
          <Button buttonType="submit" type="primary" isLoading={submitting}>
            <Trans i18nKey="network:forms_components_save_button" />
          </Button>
        </Row>
      </form>
    );
  }
}

export default withTranslation()(reduxForm({
  form: 'network-components',
  initialValues: {
    test: true,
    [EComponentTypes.SCHEDULE]: false,
    [EComponentTypes.FLEXCHANGE]: false,
  },
})(NetworkComponentsForm));
